import { useCallback } from 'react';
import type { CheckboxContainerProps, CheckboxOwnProps } from './checkbox.js';

export const useCheckbox = (props: CheckboxOwnProps): CheckboxContainerProps => {
  const { onChange, onBlur } = props;

  const handleChange = useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChange(checked);
      onBlur();
    },
    [onBlur, onChange]
  );

  return { handleChange };
};
